import { Logo } from '@air/marketing-primitives';
import { Box, BoxProps } from '@air/zephyr';
import Link from 'next/link';

import { AgencyContainer } from '~/old-marketing/components/agency/AgencyContainer';
import { Routes } from '~/old-marketing/constants/Routes';

export const AgencyHeader = ({ tx }: Pick<BoxProps, 'tx'>) => {
  return (
    <Box as="header" tx={{ display: 'flex', alignItems: 'center', height: 72, ...tx }}>
      <AgencyContainer>
        <Link href={Routes.root} passHref>
          <Box as="a" tx={{ display: 'block', height: [24, 28], mr: 24, color: 'inherit' }}>
            <Logo css={{ fill: 'currentColor', height: '100%' }} />
          </Box>
        </Link>
      </AgencyContainer>
    </Box>
  );
};
